import React, { Component } from 'react';

import { CSSTransitionGroup } from 'react-transition-group';
import { FaAngleRight as ArrowRight, FaAngleDown as ArrowDown } from 'react-icons/fa';

import { colors } from 'helpers/ColorHelper';

export default class Collapsible extends Component {
  UNSAFE_componentWillMount() {
    this.setState({ collapsed: true });
  }

  toggleCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
    if (this.props.onClick) {
      this.props.onClick(this.state.collapsed);
    }
  };

  render() {
    const { header, children, onlyShowMultiple } = this.props;

    const arrowIcon = this.state.collapsed ? <ArrowRight /> : <ArrowDown />;

    if (onlyShowMultiple && (!children || children.length < 2)) return header;

    return (
      <CSSTransitionGroup
        transitionName="fade_in"
        style={{ width: '100%' }}
        transitionEnterTimeout={200}
        transitionLeaveTimeout={200}
      >
        <div style={this.props.style}>
          <button
            type="button"
            className="link-button"
            onClick={this.toggleCollapse}
            style={{
              display: 'flex',
              alignItems: 'center',
              color: colors.GRAY,
            }}
          >
            {arrowIcon}
            <div style={{ flexGrow: '1' }}> {header} </div>
          </button>

          {!this.state.collapsed && children}
        </div>
      </CSSTransitionGroup>
    );
  }
}
